<template>
    <!-- form fields for the opportunities section -->

    <section class="flex-column form-fields-opportunities">
        <!-- THE OPPORTUNITY : NAME -->
        <el-form-item
            prop="name"
            :label="$t.__('thirds.thirdscomponents.FormFieldsOpportunity.opportunity_name')"
        >
            <el-input
                autocomplete="off"
                data-bot="opp-overview__main--name"
                v-model="name"
                ref="name"
            ></el-input>
        </el-form-item>

        <!-- THE OPPORTUNITY : AMOUNT -->
        <el-form-item
            prop="amount"
            :label="$t.__('common.labels.potential_amount')"
            class="prelative wp-5"
        >
            <el-input
                type="number"
                data-bot="opp-overview__main--amount"
                class="aleft"
                v-model="amount"
            />
            <span class="fc-unselectable pabsolute fs-5 el-input-icons__percentage">{{
                currency
            }}</span>
        </el-form-item>

        <!-- THE OPPORTUNITY : DEADLINE -->
        <el-form-item prop="deadline" :label="$t.__('common.labels.expected_close_date')">
            <date-input
                mode="edit"
                data-bot="opp-overview__main--deadline"
                v-model="deadline"
                class="wp-5"
                type="date"
                :defaultValue="currentDate"
                format="dmy"
                :options="dateOptions"
            />
        </el-form-item>

        <!-- THE OPPORTUNITY : SOURCE RATE -->
        <el-form-item
            prop="sourceRate"
            :label="$t.__('thirds.thirdscomponents.FormFieldsOpportunity.source_category')"
        >
            <el-select
                v-model="sourceRate"
                ref="sourceRate"
                class="wp-10"
                :placeholder="
                    $t.__('thirds.thirdscomponents.FormFieldsOpportunity.select_source_category')
                "
                data-bot="opp-overview__main--source-rate"
            >
                <el-option
                    v-for="option in listings.sourceRateList"
                    data-bot="opp-overview__main--source-rate-list"
                    ref="sourceRate"
                    :key="option.value"
                    :value="option"
                    :disabled="option.disabled"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- THE OPPORTUNITY : SOURCE -->
        <el-form-item prop="source" v-if="hasSourceRate" :label="$t.__('common.labels.source')">
            <el-select
                v-model="source"
                ref="source"
                class="wp-10"
                :placeholder="$t.__('thirds.thirdscomponents.FormFieldsOpportunity.select_source')"
                data-bot="opp-overview__main--source"
            >
                <el-option
                    v-for="option in listings.sourceList"
                    data-bot="opp-overview__main--source-list"
                    :key="option.value"
                    ref="source"
                    :value="option"
                    :label="option.label"
                ></el-option>
            </el-select>
        </el-form-item>

        <h4 class="gray-60 m-0 mt-5 mb-2">{{ $l10n.__('Informations pipeline') | upperCase }}</h4>

        <!-- THE OPPORTUNITY : PIPELINE -->
        <el-form-item prop="pipeline" :label="$t.__('common.labels.pipeline')">
            <el-select
                v-model="pipeline"
                ref="pipeline"
                class="wp-10"
                :placeholder="
                    $t.__('thirds.thirdscomponents.FormFieldsOpportunity.select_pipeline')
                "
                data-bot="opp-overview__main--pipeline"
            >
                <el-option
                    v-for="option in listings.pipelineList"
                    data-bot="opp-overview__main--pipeline-list"
                    ref="pipeline"
                    :key="option.value"
                    :value="option"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- THE OPPORTUNITY : STEP -->
        <el-form-item prop="step" v-if="hasPipeline" :label="$t.__('common.labels.step')">
            <el-select
                v-model="step"
                ref="step"
                class="wp-10"
                :placeholder="$t.__('thirds.thirdscomponents.FormFieldsOpportunity.select_step')"
                data-bot="opp-overview__main--step"
            >
                <el-option
                    v-for="option in listings.stepList"
                    data-bot="opp-overview__main--step-list"
                    :key="option.value"
                    :value="option"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>

        <!-- THE OPPORTUNITY : PERCENTAGE -->
        <el-form-item
            prop="percentage"
            :label="$t.__('common.labels.probability')"
            class="prelative wp-5"
        >
            <el-input
                type="number"
                class="aleft"
                v-model="percentage"
                ref="percentage"
                data-bot="opp-overview__main--percentage"
            />
            <span class="fc-unselectable pabsolute fs-5 el-input-icons__percentage">%</span>
        </el-form-item>
    </section>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import DateInput from 'vcomponents/inputs/DateInput.vue';

const corpStore = createNamespacedHelpers('corp');
export default {
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        error: {
            type: [Object, Array],
            required: false,
        },
    },
    components: {
        DateInput,
    },
    data() {
        return {
            baseOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        };
    },
    computed: {
        ...corpStore.mapGetters(['datePickerFormat']),
        currentDate() {
            return new Date();
        },
        hasSourceRate() {
            return !_.isNil(this.sourceRate) ? true : false;
        },
        hasPipeline() {
            return !_.isNil(this.pipeline) ? true : false;
        },
        name: {
            get() {
                return this.$store.getters[`${this.currentStore}/getName`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setName`, value);
            },
        },
        percentage: {
            get() {
                return this.$store.getters[`${this.currentStore}/getPercentage`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setPercentage`, value);
            },
        },
        amount: {
            get() {
                return this.$store.getters[`${this.currentStore}/getAmount`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setAmount`, value);
            },
        },
        deadline: {
            get() {
                return this.$store.getters[`${this.currentStore}/getDeadline`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setDealine`, value);
            },
        },
        sourceRate: {
            get() {
                return this.$store.getters[`${this.currentStore}/getSourceRate`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setSourceRate`, value);
                this.$store.dispatch(`${this.currentStore}/commitSourceRate`, value);
            },
        },
        source: {
            get() {
                return this.$store.getters[`${this.currentStore}/getSource`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setSource`, value);
            },
        },
        pipeline: {
            get() {
                return this.$store.getters[`${this.currentStore}/getPipeline`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setPipeline`, value);
                this.$store.dispatch(`${this.currentStore}/commitSteps`, value);
            },
        },
        step: {
            get() {
                return this.$store.getters[`${this.currentStore}/getStep`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setStep`, value);
                if (!!this.$store.getters[`${this.currentStore}/getPercentageFunnel`]) {
                    this.$store.commit(`${this.currentStore}/setPercentage`, value.proba);
                }
            },
        },
        listings() {
            return this.$store.getters[`${this.currentStore}/getListings`];
        },
        dateOptions() {
            return {
                ...this.baseOptions,
                disabledDate: (time) => {
                    return time.getTime() < Date.now();
                },
            };
        },
        currency() {
            return window.App.numformat.currencysymbol;
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.form-fields-opportunities {
    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .el-input input[type='number'] {
        padding-right: 32px;
    }
    .el-input-icons__percentage,
    .el-input-icons__amount {
        right: 10px;
        line-height: 32px;
        font-weight: $font-weight-light;
    }

    .el-form-item .el-form-item__content .el-date-editor {
        width: 100%;
    }
}
</style>
